import useStationStore from './useStationStore';

/**
 * 🏠 방송국 데이터 관련 훅
 */
export const useStationData = () => {
  return useStationStore((state) => state.data);
};

export const useStationDataActions = () => {
  return useStationStore((state) => state.dataActions);
};

/**
 * 👤 사용자 권한 관련 훅
 */
export const useStationUser = () => {
  return useStationStore((state) => state.user);
};

export const useStationUserActions = () => {
  return useStationStore((state) => state.userActions);
};

/**
 * 💼 비즈니스 로직 관련 훅
 */
export const useStationBusiness = () => {
  return useStationStore((state) => state.business);
};

export const useStationBusinessActions = () => {
  return useStationStore((state) => state.businessActions);
};

/**
 * 🎨 UI 상태 관련 훅
 */
export const useStationUI = () => {
  return useStationStore((state) => state.ui);
};

export const useStationUIActions = () => {
  return useStationStore((state) => state.uiActions);
};

/**
 * 전체 스토어 액션 훅
 */
export const useStationActions = () => {
  return useStationStore((state) => ({
    reset: state.reset,
    initialize: state.initialize,
  }));
};

/**
 * 🚀 편의를 위한 특정 데이터 접근 훅들
 */
export const useStationDetail = () => {
  return useStationStore((state) => state.data.station.detail);
};

export const useStationDisplay = () => {
  return useStationStore((state) => state.data.station.display);
};

export const useStationChannelArt = () => {
  return useStationStore((state) => state.data.station.channelArt);
};

export const useStationUserPermissions = () => {
  return useStationStore((state) => state.user.userPermissions);
};

export const useStationSubscription = () => {
  return useStationStore((state) => state.business.subscription);
};
